export default "__VITE_ASSET__BnhYai7C__"